import { useState } from 'react'

import { Item } from '../../models/Item'
import { AddressPicker } from '../common/AddressPicker'
import { ConfirmationModal } from '../common/modals/ConfirmationModal'

type Props = {
    isOpen: boolean
    item: Item
    onClose: () => void
    onConfirm: (item: Item) => void
}
export function ItemLocationModal({ isOpen, onClose, onConfirm, item }: Props) {
    const [scratchItem, setScratchItem] = useState<Item>(item)

    return (
        <ConfirmationModal
            title="Location"
            isOpen={isOpen}
            onClose={() => {
                onClose()
            }}
            onConfirm={() => {
                onConfirm(scratchItem)
            }}
        >
            <AddressPicker
                size="medium"
                onSelect={(address) => {
                    setScratchItem((i) =>
                        i?.clone({
                            location: address,
                            is_virtual: false,
                            client_selects_location: false,
                        })
                    )
                }}
            />
        </ConfirmationModal>
    )
}
